/**
 * @desc 监控
 * @time 2023-08-24 17:32:38
 * @user simxin
 */

import { mountSensor } from './sensor';
// import { mountAegis } from './aegis';

export const mountMonitor = async () => {
  mountSensor();
  // mountAegis();
};
